import { render, staticRenderFns } from "./CollectedPosts.vue?vue&type=template&id=d8c0f27a&scoped=true&"
import script from "./CollectedPosts.vue?vue&type=script&lang=js&"
export * from "./CollectedPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c0f27a",
  null
  
)

export default component.exports